import { createApp } from 'vue'
import App from '@us/app/App.vue'
import initRouter from '@us/app/router'
import i18n from '@shared/localization'
import { initApi } from '@shared/api-client'
import directives from '@shared/directives'
import Tracker from '@shared/Tracker'
import updateInitialPathAndQueryWithTrackingData from '@us/app/helpers/updateInitialPathAndQueryWithTrackingData.js'
import { generateSignupContext } from '@shared/utils'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import useUsStore from '@us/app/stores/useUsStore.js'

// replace corporate and query from tracking map before router, tracker, and signupContext are initialized
updateInitialPathAndQueryWithTrackingData()

const pinia = createPinia()
pinia.use(createPersistedState())

const app = createApp(App)

Object.keys(directives).forEach((key) => {
  app.directive(key, directives[key])
})

app.use(pinia)
const usStore = useUsStore()

app.use(i18n)

Tracker.initDatadog()
Tracker.initSnowplow()

app.use(initRouter())
initApi()

usStore.updateSignupContext(generateSignupContext())

const appSpinner = document.querySelector('#app-spinner')
if (appSpinner != null) {
  appSpinner.parentNode.removeChild(appSpinner)
}
app.mount('#app')

export default app
